// The real "today" — relative dates, days-until and overdue maths all measure
// from now. (This was once frozen at 2026-07-10, so everything read ~2 weeks off.)
const TODAY = new Date();

/* A bare YYYY-MM-DD is parsed as UTC midnight, which renders as the day before
   anywhere west of Greenwich — so a payment recorded today shows as yesterday.
   Date-only strings are calendar dates, not instants: read them as local. */
export function fmtDate(iso?: string, opts: Intl.DateTimeFormatOptions = { day: "numeric", month: "short", year: "numeric" }) {
  if (!iso) return "—";
  const dateOnly = /^\d{4}-\d{2}-\d{2}$/.exec(iso);
  const d = dateOnly ? new Date(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)) : new Date(iso);
  if (isNaN(+d)) return "—";
  return d.toLocaleDateString("en-US", opts);
}
export function fmtDay(iso?: string) { return fmtDate(iso, { day: "numeric", month: "short" }); }
/** The app's "today" as an ISO date — for logic that needs to plan from now. */
export function todayISO() { return TODAY.toISOString().slice(0, 10); }

export function relative(iso?: string) {
  if (!iso) return "";
  const d = new Date(iso);
  const days = Math.round((+d - +TODAY) / 86400000);
  const abs = Math.abs(days);
  if (days === 0) return "today";
  if (days === 1) return "tomorrow";
  if (days === -1) return "yesterday";
  if (days < 0) return `${abs}d ago`;
  if (days < 14) return `in ${days}d`;
  if (days < 60) return `in ${Math.round(days / 7)}w`;
  return `in ${Math.round(days / 30)}mo`;
}
export function daysUntil(iso?: string) {
  if (!iso) return Infinity;
  return Math.round((+new Date(iso) - +TODAY) / 86400000);
}
export function initials(name: string) {
  return name.split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? "").join("");
}
